import React from 'react';


import withNavigate from "../../utils/withNavigate";
import DeliveryDetail from "./DeliveryDetail";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";


class DeliveryTable extends React.Component {
    render() {
        return (
            <CommonPaginatedTable
                title={this.props.showTitle?'Бизнес-процессы':null}
                data={this.props.deliveries}
                fields={[
                    {
                        title: '',
                        visible: true,
                        component: DeliveryDetail,
                        componentProps: {
                            showOpportunity: true,
                            showAccount: true,
                            overlay: true,
                        },
                        callBack: this.props.callBack,
                        width: '0px',
                        position: 'unset',
                    },
                    {
                        title: 'Тип',
                        name: 'delivery.xtype_human',
                        visible: true,
                        chip: true,
                        color_rule: (value, comparison) => ('primary'),
                        position: 'unset',
                    },
                    {
                        title: 'Бизнес-процесс',
                        name: 'delivery.title',
                        visible: true,
                        position: 'unset',
                    },
                    {
                        title: 'Сделка',
                        name: 'delivery.opportunity.short_name',
                        visible: this.props.showOpportunity,
                        linkPattern: '/opportunity/detail/:linkParam',
                        linkParam: 'delivery.opportunity.id',
                        linkTarget: '_blank',
                        position: 'unset',
                    },
                    {
                        title: 'Компания',
                        name: 'delivery.opportunity.account.nameshort',
                        visible: this.props.showAccount,
                        linkPattern: '/account/detail/:linkParam',
                        linkParam: 'delivery.opportunity.account.id',
                        linkTarget: '_blank',
                    },
                    {
                        title: 'Стадия',
                        name: 'stage.title',
                        visible: true,
                        chip: true,
                        color_rule: (value, comparison) => (value),
                        color_value: 'stage.color',
                        position: 'unset',
                    },
                    {
                        title: 'Прошло',
                        name: 'delay.0',
                        visible: true,
                        chip: true,
                        color_rule: (value, comparison) => (value>comparison?'danger':'success'),
                        color_value: 'delay.0',
                        color_comparison: 'stage.end_delay',
                        width: '80px',
                        position: 'unset',
                    },
                    {
                        title: 'Дедлайн',
                        name: 'stage.end_delay',
                        visible: true,
                        chip: true,
                        color_rule: (value, comparison) => ('primary'),
                        width: '80px',
                        position: 'unset',
                    },
                    {
                        title: 'Исполнитель',
                        name: ['operator.user.first_name', 'operator.user.last_name'],
                        visible: this.props.showOperator,
                        position: 'unset',
                    },

                ]}
            />
        )
    }
}

export default withNavigate(DeliveryTable);
